(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    (function() {
    var ft = document.querySelectorAll('.footer_tab');
    ft.forEach((t) => {
      t.addEventListener('click', function() {
        const section = this.getAttribute('data-section');
        const target = document.getElementById('tab_' + section);
        const isOpen = this.classList.contains('open');
        ft.forEach(el => {
          el.classList.remove('open');
          const sec = el.getAttribute('data-section');
          const link = document.getElementById('tab_' + sec);
          if (link) link.classList.remove('open_tab');
        });
        if (!isOpen) {
          this.classList.add('open');
          if (target) target.classList.add('open_tab');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
